import Cookies from "js-cookie";
function exposureListen(_ref) {
  var $element = _ref.$element,
    self = _ref.self,
    item = _ref.item;
  var debug = self.options.debug;
  if ($element) {
    //防止重绑定设置
    var isExposure = $element.getAttribute("exposure");
    if (isExposure === "true") return;
    // 绑定事件判断在可视范围上报曝光
    var inter = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        self.eventObj = $element;
        self.params = {
          name: item.event.name,
          params: Object.assign(Object.assign({}, item.event.params), self.parseWaitMetaDictFields(item))
        };
        self.trackEvent();
      }
    }, {
      threshold: [0.01]
    });
    $element.setAttribute("exposure", "true");
    inter.observe($element);
  } else {
    var isLogTracking = Cookies.get("tracking");
    if (debug || !!isLogTracking) {
      console.log("XPath does not exist ".concat(item.event.params.trigger_name, ":").concat(item.trigger.condition.value), item);
    }
  }
}
export default exposureListen;